module.exports = "/images/vendor/flag-icon-css/flags/4x3/zw.svg?6ac3949a90f1620a287b06e2b4cb3bc2";